/**
 * Dane wrażliwe dla widżetu zgłoszeń (Ybug): PESEL, paszport, karta pobytu,
 * skany dokumentów, numer konta. Element z atrybutem `data-ybug-sensitive`
 * jest anonimizowany w przeglądarce, zanim powstanie zrzut ekranu — dane
 * nie trafiają na serwery Ybug.
 *
 * Decyduje typ pola, suma kontrolna i nazwa klucza. Lista nazw jest nieszczelna
 * z założenia (schemat żyje), więc typy plikowe/tożsamości/podpisu/adresu są
 * wrażliwe zawsze, niezależnie od klucza.
 */
const SENSITIVE_TYPES = new Set(["pesel", "bank_account", "file", "idenfy", "simple_sign", "address"]);
const SENSITIVE_CHECKSUMS = new Set(["pesel", "iban", "nip"]);
const SENSITIVE_KEY =
  /pesel|pasz|passport|karta|dokument|konto|iban|nip$|^nip|dowod|wiza|zezwolen|legitymacj|decyzj/i;

interface Describable {
  type?: string | null;
  key?: string | null;
  validation?: { checksum?: string | null } | null;
}

export function isSensitive(field: Describable): boolean {
  return (
    SENSITIVE_TYPES.has(field.type ?? "") ||
    SENSITIVE_CHECKSUMS.has(field.validation?.checksum ?? "") ||
    SENSITIVE_KEY.test(field.key ?? "")
  );
}

/** Rozpakowywane w JSX: `<span {...sensitive(field)}>`. */
export function sensitive(field: Describable): { "data-ybug-sensitive"?: "" } {
  return isSensitive(field) ? { "data-ybug-sensitive": "" } : {};
}
